<div>
  <ng-select [items]="contact?.address || []"
    bindLabel="address_street"
    bindValue="address_id"
    [ngModel]="address_id?.value"
    (ngModelChange)="address_id?.setValue($event)"
    placeholder="Select Address">
    <ng-template ng-label-tmp let-item="item" let-clear="clear">
      <span class="custom-label">{{ item.address_type | titlecase }} | {{ item.address_city | titlecase }} Address</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <app-address-view [address]="item"></app-address-view>
    </ng-template>
  </ng-select>
</div>

@if (show_selected) {
  @if (address_id?.value) {
    <div class="mt-2">
      <app-address-view [address]="selectedAddress"></app-address-view>
    </div>
  }
}

